<template>
 <div>
    <b-row>
      <b-col sm="12">
        <b-overlay :show="showOverlay" rounded>
          <b-card>
            <h3 class="chr-h3"> <b-icon icon="globe2"></b-icon> <translate>Bookings</translate></h3>
            <b-col sm="12">
              <b-row>
                <SearchForm
                  :params="model.params"
                  :results="model.results"
                  @search="onSearch"
                />
              </b-row>
            </b-col>
          </b-card>
        </b-overlay>
        <template  v-if="results.length">
          <b-card class="my-3">
            <b-row>
              <b-col sm="4"><h6 class="mb-0"><b>{{results.length}}</b> results</h6> </b-col>
              <b-col sm="8">Filtre</b-col>
            </b-row>
          </b-card>
          <b-card>
            <!-- {{results}} -->
            <BookingResults
              :results="model.results"
              @view="onView"
              />
          </b-card>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import model from './services/model'

import SearchForm from './components/search_form'
import BookingResults from './components/booking_results'
// import SortFields from '../shared/components/sort_fields'

export default {
  name: 'BookingSearch',
  components: { SearchForm, BookingResults },
  data () {
    return {
      model,
      showOverlay: false,
      modal: false,
      currentBooking: null
    }
  },
  computed: {
    results () {
      return model.results
    }
  },
  methods: {
    onSearch (params) {
      this.showOverlay = true
      model.search(params)
        .finally(() => { this.showOverlay = false })
    },
    onView (id) {
      this.$router.push({
        name: 'Private/Bookings/View',
        params: {
          Id: id
        }
      })
    },
    editPassenger (id) {
      this.currentBooking = id
      this.modal = true
    },
    close () {
      this.modal = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
